<template>
	<span>
		<v-tooltip v-bind="tooltipDirection" v-if="showTooltip">
			<template v-slot:activator="{on}">
			<span
				v-on="on"
				:tabindex="setAriaLabel ? '0' : undefined"
				:aria-label="setAriaLabel ? text : undefined"
			>
				<slot></slot>
			</span>
			</template>
			<span v-if="allowHTML" v-html="text"></span>
			<span v-else v-html="escapedText"></span>
		</v-tooltip>
		<slot v-else></slot>
	</span>
</template>

<script>
import {escape} from 'lodash';

export default {
	name:  'Tooltip',
	props: {
		text: {
			type:     String,
			required: true,
		},
		setAriaLabel: {
			type:    Boolean,
			default: false,
		},
		direction: {
			type:    String,
			default: 'bottom',
		},

		allowHTML: {
			type:    Boolean,
			default: false,
		},
	},

	computed: {
		tooltipDirection() {
			const direction = this.direction.toLowerCase();

			return {
				bottom: direction === 'bottom',
				top:    direction === 'top',
				left:   direction === 'left',
				right:  direction === 'right',
			};
		},

		escapedText() {
			return escape(this.text).replace(/\n/g, '<br/>');
		},

		showTooltip() {
			return this.isWebApp && this.text !== ''
		},
	},
}
</script>

<style scoped>

</style>
